import { useState } from 'react';

import { GanttAccessRightsEnum } from '@thinknet-gmbh/platform-common';

import { ICompanyGantt } from 'src/pages/settings/components/company/company.interfaces';

import { GanttEdit } from './components/gantt-edit';
import { GanttInfo } from './components/gantt-info';

const CompanyGantts = ({
  gantts,
  companyId,
  member,
}: {
  gantts: ICompanyGantt[];
  companyId: string;
  member: any;
}) => {
  const [isEdit, setIsEdit] = useState(false);

  return isEdit ? (
    <GanttEdit
      data={gantts.filter(gantt =>
        member.ganttsAccess.some(
          ({ ganttId, accessRight }: any) =>
            ganttId === gantt._id && accessRight === GanttAccessRightsEnum.EDIT
        )
      )}
      companyId={companyId}
      onCancelEdit={() => setIsEdit(false)}
    />
  ) : (
    <GanttInfo
      data={gantts}
      companyId={companyId}
      onClickEdit={() => setIsEdit(true)}
      member={member}
    />
  );
};

export default CompanyGantts;
